module.exports = __webpack_public_path__ + "img/interpeople1_50_40.a15c6048.jpg";